<template>
  <div class="body">
    <Title
      title="Cola de datos"
      subtitle="Revisa sus estados y tasa de consumo"/>
    <el-row :gutter="30">
      <Item v-for="(queue, index) in queues"
            :key="index"
            :maxLen="maxLen"
            :queue="queue"/>
    </el-row>
  </div>
</template>

<script>
import Item from '../components/queue/Item.vue';
import Title from '../components/base/Title.vue';
import { apiRequest } from '../../backend/vue-axios/axios';

export default {
  name: 'Queues',
  components: {
    Item,
    Title,
  },
  data() {
    return {
      queues: [
        {
          db: 9,
          queue: 'trlSocs',
          len: 0,
          unit: 'SOCS',
          name: 'SOCs desde TRL',
          rates: [],
        },
        {
          db: 8,
          queue: 'TRL',
          len: 0,
          unit: 'Totalizaciones',
          name: 'Totalizaciones TRL',
          rates: [],
        },
        {
          db: 10,
          queue: 'Paperless',
          len: 0,
          unit: 'Totalizaciones',
          name: 'Totalizaciones Paperless',
          rates: [],
        },
        {
          db: 12,
          queue: 'SDD',
          len: 0,
          unit: 'SOCS',
          name: 'SDD',
          rates: [],
        },
        {
          db: 13,
          queue: 'trenLogistico',
          len: 0,
          unit: 'SOCS',
          name: 'Tren Logístico',
          rates: [],
        },
      ],
    };
  },
  mounted() {
    this.getQueues();
  },
  methods: {
    getQueues() {
      this.queues.forEach((queue) => {
        this.getQueueData(queue.db, queue.queue);
      });
    },
    getQueueData(id, queue) {
      apiRequest({
        module: 'geocoding',
        service: 'get_queue_data',
        pathparam: { id, queue },
      }).then((response) => {
        Object.entries(response.data).forEach(([k, v]) => {
          this.queues.find(q => q.db === id && q.queue === queue)[k] = v;
        });
      }).catch(() => {
        this.$notify({
          type: 'error',
          title: 'Error al cargar la cola',
          message: 'Vuelva a intentarlo más tarde',
        });
      });
    },
  },
  computed: {
    maxLen() {
      return Math.max.apply(null, this.queues.map(q => q.len));
    },
  },
};
</script>

<style lang="scss" scoped>
  .queues {
    display: flex;
    flex-wrap: wrap;
  }
</style>
